<template>
  <!-- <div id="app"> -->

    <router-view />

  <!-- </div> -->
</template>


<script>

import config from "@/config"

export default {
  created(){
    if (window.__wxjs_environment !== 'miniprogram') {
      document.title = "K11 Registration";
    }
  },
  name: "app",
  data() {
    return {
      isRouterAlive: true
    };
  },
  components:{

  }
};
</script>
